module.exports = __webpack_public_path__ + "static/media/quickbooks_connect_btn.c072cd3f.svg";